import React from "react";

// Reusable layout wrapper for legal/info pages
export function LegalLayout({ kicker, title, lastUpdated, children }) {
    return (
        <div className="max-w-4xl mx-auto px-5 md:px-10 pt-10 pb-20">
            <div className="text-xs font-bold uppercase tracking-widest text-neutral-600">
                {kicker}
            </div>
            <h1 className="font-display mt-2 text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
                {title}
            </h1>
            {lastUpdated && (
                <div className="mt-3 text-sm text-neutral-600 font-semibold">
                    Last updated: {lastUpdated}
                </div>
            )}
            <article className="mt-8 nb-border-4 nb-shadow rounded-3xl bg-white p-6 md:p-10 prose-content space-y-6 text-base md:text-lg leading-relaxed">
                {children}
            </article>
        </div>
    );
}

export const H2 = ({ children }) => (
    <h2 className="font-display text-2xl md:text-3xl font-black tracking-tight mt-8 first:mt-0">
        {children}
    </h2>
);

export const P = ({ children }) => (
    <p className="text-neutral-800">{children}</p>
);

export const UL = ({ children }) => (
    <ul className="list-disc ml-6 space-y-2 text-neutral-800">{children}</ul>
);
